import React from 'react';
import { IRubric } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import { HolisticRubricProps }
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/HolisticRubric/HolisticRubric';
import { AnalyticRubricProps }
  from '@/components/staffer/ExerciseBuilder/Rubric/AddRubricModal/AnalyticRubric/AnalyticRubric';
import I18n from 'i18n-js';
import HolisticRubricPreview from './HolisticRubricPreview';
import AnalyticRubricPreview from './AnalyticRubricPreview';
import analyticRubricThumbnail from '../../icons/analytic-rubric-table.svg';

type RubricPreviewProps = {
  analyticColumnSizes?: { criterion?: string, level?: string },
  analyticRubricProps?: Partial<AnalyticRubricProps>,
  holisticColumnSizes?: { description?: string, score?: string },
  holisticRubricProps?: Partial<HolisticRubricProps>,
  rubric: IRubric,
  useThumbnail?: boolean,
};

const RubricPreview = ({
  analyticColumnSizes,
  analyticRubricProps = {},
  holisticColumnSizes,
  holisticRubricProps = {},
  rubric,
  useThumbnail = false,
}: RubricPreviewProps) => {
  const locale = (I18n.locale?.toLowerCase() || 'en') as Lowercase<Locale>;

  if (rubric.rubric_type === 'holistic') {
    return (
      <HolisticRubricPreview
        columnSizes={holisticColumnSizes}
        holisticRubricProps={holisticRubricProps}
        locale={locale}
        rubric={rubric}
      />
    );
  }

  if (rubric.rubric_type === 'analytic') {
    if (useThumbnail) {
      return (
        <img
          alt="Analytic rubric preview"
          className="tw-w-full tw-h-auto"
          src={analyticRubricThumbnail}
        />
      );
    }

    return (
      <AnalyticRubricPreview
        analyticRubricProps={analyticRubricProps}
        columnSizes={analyticColumnSizes}
        locale={locale}
        rubric={rubric}
      />
    );
  }

  return null;
};

export default RubricPreview;
